import React, { forwardRef } from "react"
import styled from "styled-components"

const FourDetailedViewSVG = forwardRef((props, ref) => {
  return (
    <SVGWrapper ref={ref} width={props.width || 200} color={props.color} version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 225">
      <title>New Project</title>
      <path id="Layer 1" className="s0" d="m0 0h400v225h-400z"/>
      <g id="Folder 1 copy">
        <path id="Layer 2" className="s1" d="m12 20c0-3.3 2.7-6 6-6h87.2c3.3 0 6 2.7 6 6v43.9c0 3.3-2.7 6-6 6h-87.2c-3.3 0-6-2.7-6-6z"/>
        <path id="Layer 2 copy" className="s1" d="m116.8 20c0-3.3 2.7-6 6-6h87.2c3.3 0 6 2.7 6 6v43.9c0 3.3-2.7 6-6 6h-87.2c-3.3 0-6-2.7-6-6z"/>
        <path id="Layer 2 copy 2" className="s1" d="m12 80.3c0-3.4 2.7-6 6-6h87.2c3.3 0 6 2.6 6 6v43.8c0 3.3-2.7 6-6 6h-87.2c-3.3 0-6-2.7-6-6z"/>
        <path id="Layer 2 copy 3" className="s1" d="m116.8 80.3c0-3.4 2.7-6 6-6h87.2c3.3 0 6 2.6 6 6v43.8c0 3.3-2.7 6-6 6h-87.2c-3.3 0-6-2.7-6-6z"/>
        <path id="Layer 3" className="s1 browser-source" d="m229 21c0-3.3 2.7-6 6-6h148c3.3 0 6 2.7 6 6v185c0 3.3-2.7 6-6 6h-148c-3.3 0-6-2.7-6-6z"/>
        <g id="Folder 3">
          <path id="Shape 3" className="s2" d="m237.3 28.6v-5h142.9v5z"/>
          <path id="Shape 3 copy" className="s2" d="m237.3 38.6v-5h142.9v5z"/>
          <path id="Shape 3 copy 2" className="s2" d="m237.3 48.6v-5h142.9v5z"/>
          <path id="Shape 3 copy 3" className="s2" d="m237.3 58.6v-5h142.9v5z"/>
          <path id="Shape 3 copy 4" className="s2" d="m237.3 68.6v-5h142.9v5z"/>
          <path id="Shape 3 copy 5" className="s2" d="m237.3 78.6v-5h142.9v5z"/>
          <path id="Shape 3 copy 6" className="s2" d="m237.3 88.6v-5h142.9v5z"/>
          <path id="Shape 3 copy 7" className="s2" d="m237.3 98.6v-5h142.9v5z"/>
          <path id="Shape 3 copy 8" className="s2" d="m237.3 108.6v-5h142.9v5z"/>
          <path id="Shape 3 copy 9" className="s2" d="m237.3 118.6v-5h142.9v5z"/>
          <path id="Shape 3 copy 10" className="s2" d="m237.3 128.6v-5h142.9v5z"/>
          <path id="Shape 3 copy 11" className="s2" d="m237.3 138.6v-5h142.9v5z"/>
          <path id="Shape 3 copy 12" className="s2" d="m237.3 148.6v-5h142.9v5z"/>
          <path id="Shape 3 copy 13" className="s2" d="m237.3 158.6v-5h142.9v5z"/>
          <path id="Shape 3 copy 14" className="s2" d="m237.3 168.6v-5h142.9v5z"/>
          <path id="Shape 3 copy 15" className="s2" d="m237.3 178.6v-5h142.9v5z"/>
          <path id="Shape 3 copy 16" className="s2" d="m237.3 188.6v-5h142.9v5z"/>
          <path id="Shape 3 copy 17" className="s2" d="m237.3 198.6v-5h142.9v5z"/>
        </g>
      </g>
    </SVGWrapper>
  )
})

export default FourDetailedViewSVG

const SVGWrapper = styled.svg`
  --color: ${props => props.color || '#fff'};
  .s0 { fill: none;stroke: var(--color);stroke-width: 10 }
  .s1 { fill: none;stroke: var(--color);stroke-width: 5 }
  .s2 { fill: var(--color) }

  .browser-source {
    stroke: var(--green-text);
    fill: var(--green-selected);
  }
`
